import { render } from "./ReferralCouponManagement.vue?vue&type=template&id=489bd532&scoped=true"
import script from "./ReferralCouponManagement.vue?vue&type=script&lang=js"
export * from "./ReferralCouponManagement.vue?vue&type=script&lang=js"

import "./ReferralCouponManagement.vue?vue&type=style&index=0&id=489bd532&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-489bd532"]])

export default __exports__